import { useGet } from "./hooks";
import { simpleStates } from "@/data/states";

const getLocationInfoByZip = async (zip) => {
  let city = "";
  let state = "";

  const [geoRes, geoErr] = await useGet(`/api/geo/zipcode/${zip}`);

  if (!geoErr) {
    city = geoRes.data.city;
    state =
      simpleStates.find((s) => s.value === geoRes.data.state)?.label || "";
  }

  return { city, state };
};

export default getLocationInfoByZip;
